<template>
  <a-modal
    :wrapClassName="$store.state.bgLight ? 'lightColor' : ''"
    :title="title"
    :width="1200"
    :visible="visible"
    :okButtonProps="{ props: { disabled: loading } }"
    cancelText="关闭"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="编号">
              <a-input placeholder="请输入编号查询" v-model="queryParam.mn"></a-input>
            </a-form-item>
          </a-col>

          <a-col :span="6">
            <a-form-item label="名称">
              <a-input placeholder="请输入名称查询" v-model="queryParam.name"></a-input>
            </a-form-item>
          </a-col>

          <a-col :span="6">
            <a-form-item label="状态">
              <j-dict-select-tag v-model="queryParam.status" dictCode="valid_status" defaultValue="全部" />
            </a-form-item>
          </a-col>

          <a-col :span="6">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchByquery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <a-alert type="info" show-icon style="margin-bottom: 16px">
      <template slot="message">
        已选择 <strong style="color: #096dd9">{{ selectedRowKeys.length }}</strong> 个站点
        <a style="margin-left: 16px" @click="onSelectChange([], [])">清空</a>
      </template>
    </a-alert>
    <a-table
      ref="table"
      bordered
      id="tables"
      rowKey="id"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="ipagination"
      :loading="loading"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
      @change="handleTableChange"
    >
    </a-table>
  </a-modal>
</template>

<script>
import { filterObj } from '@/utils/util'

import { querySiteList } from '@/api/api'
import { getAction } from '@/api/manage'

export default {
  name: 'SelectSiteListModal',
  components: {},
  props: {
    sourceSiteId: { type: Number, default: null }
  },
  data() {
    return {
      title: '选择站点',
      loading: false,
      loadSequence: 0,
      queryParam: { status: '1' },
      columns: [
        {
          title: '编号',
          align: 'center',
          dataIndex: 'mn',
          fixed: 'left',
          width: 200
        },
        {
          title: '名称',
          align: 'center',
          dataIndex: 'name'
        },
        // {
        //   title: '站点类型',
        //   align: 'center',
        //   dataIndex: 'category_dictText',
        // },
        // {
        //   title: '运营中心',
        //   align: 'center',
        //   dataIndex: 'departName',
        // },
        {
          title: '状态',
          align: 'center',
          dataIndex: 'status_dictText'
        }
      ],
      dataSource: [],
      ipagination: {
        current: 1,
        pageSize: 5,
        pageSizeOptions: ['5', '10', '20'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      isorter: {
        column: 'create_time',
        order: 'desc'
      },
      selectedRowKeys: [],
      selectionRows: [],
      visible: false,
      toggleSearchStatus: false
    }
  },
  created() {
  },
  methods: {
    loadData(arg) {
      //
      if (arg === 1) {
        this.ipagination.current = 1
      }
      let params = this.getQueryParams() //查询条件
      const sequence = ++this.loadSequence
      this.loading = true
      const request = this.sourceSiteId
        ? getAction('/site/info/factor/sync/sites', { ...params, sourceSiteId: this.sourceSiteId })
        : querySiteList(params)
      return request.then((res) => {
        if (sequence !== this.loadSequence) return
        if (res.success) {
          this.dataSource = res.result.records
          this.ipagination.total = res.result.total
        } else {
          this.dataSource = []
          this.ipagination.total = 0
          this.$message.warning(res.message || '站点加载失败')
        }
      }).catch(() => {
        if (sequence !== this.loadSequence) return
        this.dataSource = []
        this.ipagination.total = 0
        this.$message.error('站点加载失败，请重试')
      }).finally(() => {
        if (sequence === this.loadSequence) this.loading = false
      })
    },
    add(selectSite, siteIds) {
      this.visible = true
      this.edit(selectSite, siteIds)
    },
    edit(selectSite, siteIds) {
      this.queryParam = { status: '1' }
      this.dataSource = []
      this.loadData(1)
      if (!siteIds) {
        this.selectedRowKeys = []
      } else {
        this.selectedRowKeys = siteIds
      }
      if (!selectSite) {
        this.selectionRows = []
      } else {
        this.selectionRows = selectSite.map((row, index) => typeof row === 'string'
          ? { id: this.selectedRowKeys[index], name: row } : row)
      }
    },
    getQueryParams() {
      let param = Object.assign({}, this.queryParam, this.isorter)
      param.field = this.getQueryField()
      param.pageNo = this.ipagination.current
      param.pageSize = this.ipagination.pageSize
      return filterObj(param)
    },
    getQueryField() {
      let str = 'id,'
      for (let a = 0; a < this.columns.length; a++) {
        str += ',' + this.columns[a].dataIndex
      }
      return str
    },
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys
      // 表格回调只带当前页记录，保留其他页已选站点的名称和ID。
      const rows = new Map([...this.selectionRows, ...selectionRows].map(row => [row.id, row]))
      this.selectionRows = selectedRowKeys.map(id => rows.get(id)).filter(Boolean)
    },
    searchReset() {
      this.queryParam = { status: '1' }
      this.loadData(1)
    },
    handleTableChange(pagination, filters, sorter) {
      //TODO 筛选
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field
        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc'
      }
      this.ipagination = pagination

      this.loadData()
    },
    handleCancel() {
      this.loadSequence++
      this.loading = false
      this.selectionRows = []
      this.selectedRowKeys = []
      this.visible = false
    },
    handleOk() {
      if (this.loading) return
      this.$emit('choseArchive', this.selectionRows)
      this.handleCancel()
    },
    searchByquery() {
      this.loadData(1)
    },
    handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus
    }
  }
}
</script>
<style scoped>
/*@import '~@assets/less/common.less';*/
/*#tables>>>.ant-pagination-prev a, #tables>>>.ant-pagination-next a, #tables>>>.ant-pagination, #tables>>>.ant-pagination-item a {*/
/*    color: black !important;*/
/*}*/
</style>
